<app-navbar>
    <h2>Parola uitata</h2>
</app-navbar>


<div class="login-area pt-100">
    <div class="container">
        <div class="row justify-content-center">

            <div class="col-12">
                <div class="row">
                    <div class="col-md-6 col-12 mx-auto">
                        <!--Server Response-->
                        <app-form-response [serverResponse]='serverResp' *ngIf="formHasBeenSend">
                            <div class="success-content" *ngIf="serverResp === true">
                                <p class="text-white font-weight-bold mb-0">Un cod de resetare al parolei a fost trimis pe email-ul tau. Vei fi redirectionat spre pagina de resetare a parolei.</p>
                            </div>
                            <div class="error-content" *ngIf="serverResp === false">
                                <p class="text-white font-weight-bold mb-0">{{serverErrorMessages}}</p>
                            </div>
                        </app-form-response>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-12">
                <form #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)" *ngIf="!formSuccessfulSend">
                    <div class="form-group">
                        <input type="email"
                               class="form-control"
                               placeholder="Email"
                               id="email"
                               ngModel
                               name="email"
                               required
                               email
                               #email="ngModel"
                        >
                        <!--Error Message-->
                        <div class="help-block" *ngIf="!email.valid && email.touched">
                            Te rog sa introduci un email valid!
                        </div>
                    </div>

                    <div class="sub-login text-center mt-5">

                        <div class="text-center">
                            <button type="submit"
                                    class="green-button"
                                    [disabled]="!loginForm.valid">Resetare parola
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
